
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["share-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"38","viewBox":"0 0 52 52"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"26","cy":"26","fill":"#f37b8a","r":"26"}}),_c('path',{attrs:{"d":"M36.4 14.858H16.557a1.677 1.677 0 00-1.7 1.7v19.948a1.677 1.677 0 001.7 1.7h19.845a1.677 1.677 0 001.7-1.7V16.558a1.615 1.615 0 00-1.7-1.7zM21.757 34.702h-3.5V23.558h3.5zm-1.7-12.628a2.016 2.016 0 112.016-2.016 2.087 2.087 0 01-2.016 2.016zm14.645 12.629h-3.4v-5.414c0-1.273 0-2.971-1.8-2.971s-2.123 1.38-2.123 2.865v5.519h-3.5V23.558h3.29v1.486a3.654 3.654 0 013.29-1.8c3.5 0 4.139 2.335 4.139 5.306v6.155z"}})])
          )
        }
      }
    